// import React, { useEffect, Suspense, lazy } from 'react';
// import { Outlet, useLocation } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import ReactGA from "react-ga4";

// // Styles & Context
// import './App.css';
// import Context from './context';

// // Redux & API
// import { setWishlistCount } from './store/wishlistSlice';
// import { setCartCount } from './store/cartSlice';
// import { setUser } from './store/userSlice';
// import apiCall from './helper/apiCall';
// import useMobile from './hooks/useMobile';

// // --- LAZY LOADED UI COMPONENTS ---
// // This keeps the initial main.js file small
// const Header = lazy(() => import('./components/Header'));
// const Header2 = lazy(() => import('./components/Header2'));
// const Header3 = lazy(() => import('./components/Header3'));
// const Footer = lazy(() => import('./components/Footer'));
// const CheckoutFooter = lazy(() => import('./components/CheckoutFooter'));
// const AnnouncementBanner = lazy(() => import('./components/AnnouncementBanner'));
// const ReviewDrawer = lazy(() => import('./components/ReviewDrawer'));
// const WhatsAppWidget = lazy(() => import('./components/WhatsAppWidget'));
// const ToastContainer = lazy(() => import('react-toastify').then(m => ({ default: m.ToastContainer })));

// function App() {
//   const [isReviewOpen, setIsReviewOpen] = React.useState(false);
//   const [isMobile] = useMobile();
//   const location = useLocation();
//   const dispatch = useDispatch();

//   // Google Analytics
//   useEffect(() => {
//     ReactGA.send({ 
//       hitType: "pageview", 
//       page: location.pathname + location.search 
//     });
//   }, [location]);

//   // Sync User Data
//   const getUser = async () => {
//     const response = await apiCall('getUser');
//     if (response.success) {
//       dispatch(setCartCount(response?.data?.cart_count || 0));
//       dispatch(setWishlistCount(response?.data?.wishlist_count || 0));
//       dispatch(setUser(response.data));      
//     }
//   };

//   useEffect(() => {
//     getUser();
//   }, []);

//   // Route Helpers
//   const isCheckoutPage = location.pathname === '/checkout';
//   const isDigital = location.pathname.includes('/digital');
//   const isPaymentCallback = location.pathname === '/payment-callback';
//   const isUserPage = location.pathname.startsWith('/user');
//   const isProductPage = location.pathname.startsWith('/product') || location.pathname.startsWith('/collection');

//   const getHeaderComponent = () => {
//     if (isCheckoutPage || isPaymentCallback || isDigital) return null;
//     if (isMobile && isProductPage) return <Header3 location={location} />;
//     if (isMobile && isUserPage) return <Header2 location={location} />;
//     return <Header />;
//   };

//   const getFooterComponent = () => {
//     if (isCheckoutPage) return <CheckoutFooter/>;
//     if (isPaymentCallback || isDigital) return null;
//     return <Footer />;
//   };

//   return (
//     <Context.Provider value={{ getUser }}>
//       <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
//         <ToastContainer position='top-center' />
//         <AnnouncementBanner /> 
        
//         {getHeaderComponent()}
        
//         <main className='min-h-[calc(100vh-140px)]'>
//           <Outlet />
//         </main>
//         {/* 3. THE TRIGGER BUTTON (Floating Sidebar Style) */}
//         <button
//           onClick={() => setIsReviewOpen(true)}
//           style={{ backgroundColor: 'rgb(41, 64, 96)' }} // Your Brand Color
//           className="fixed right-0 top-1/2 -translate-y-1/2 z-[50] text-white px-2 py-8 rounded-l-lg hover:pr-4 transition-all duration-300 [writing-mode:vertical-lr] text-[10px] font-bold uppercase tracking-[0.3em] shadow-2xl border-l border-y border-white/20"
//         >
//           Reviews
//         </button>

//                 {/* 4. THE DRAWER COMPONENT */}
//                 <ReviewDrawer
//                     isOpen={isReviewOpen} 
//                     onClose={() => setIsReviewOpen(false)} 
//                 />
//         <WhatsAppWidget />
//         {getFooterComponent()}
//       </Suspense>
//     </Context.Provider>
//   );
// }

// export default App;

import React, { useEffect, Suspense, lazy } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ReactGA from "react-ga4";

// Styles & Context
import './App.css';
import Context from './context';

// Redux & API
import { setWishlistCount } from './store/wishlistSlice';
import { setCartCount } from './store/cartSlice';
import { setUser } from './store/userSlice';
import apiCall from './helper/apiCall';
import useMobile from './hooks/useMobile';
import KanthasriLoader from './components/KanthasriLoader';

// --- LAZY LOADED UI COMPONENTS ---
const Header = lazy(() => import('./components/Header'));
const Header2 = lazy(() => import('./components/Header2'));
const Header3 = lazy(() => import('./components/Header3'));
const Footer = lazy(() => import('./components/Footer'));
const CheckoutFooter = lazy(() => import('./components/CheckoutFooter'));
const AnnouncementBanner = lazy(() => import('./components/AnnouncementBanner'));
const ReviewDrawer = lazy(() => import('./components/ReviewDrawer'));
const WhatsAppWidget = lazy(() => import('./components/WhatsAppWidget'));
const ToastContainer = lazy(() => import('react-toastify').then(m => ({ default: m.ToastContainer })));

function App() {
  const [isReviewOpen, setIsReviewOpen] = React.useState(false);
  const [isMobile] = useMobile();
  const location = useLocation();
  const dispatch = useDispatch();

  // Google Analytics
  useEffect(() => {
    ReactGA.send({ 
      hitType: "pageview", 
      page: location.pathname + location.search 
    });
  }, [location]);

  // Sync User Data
  const getUser = async () => {
    const response = await apiCall('getUser');
    const lastFetch = localStorage.getItem('coupons_last_fetched');
    const now = new Date().getTime();
    const oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    if (!lastFetch || (now - lastFetch > oneDay)) {
    const couponResponse = await apiCall('getCoupons');
    if (couponResponse?.success && couponResponse?.data) {
      localStorage.setItem('available_coupons', JSON.stringify(couponResponse.data));
      localStorage.setItem('coupons_last_fetched', now.toString());
      //console.log('Coupons refreshed from server');
    }
  }

    if (response.success) {
      dispatch(setCartCount(response?.data?.cart_count || 0));
      dispatch(setWishlistCount(response?.data?.wishlist_count || 0));
      dispatch(setUser(response.data));      
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  // Route Helpers
  const isCheckoutPage = location.pathname === '/checkout';
  const isGuestCheckoutPage = location.pathname === '/guest-checkout';
  const isDigital = location.pathname.includes('/digital');
  const isPaymentCallback = location.pathname === '/payment-callback';
  const isUserPage = location.pathname.startsWith('/user');
  const isProductPage = location.pathname.startsWith('/product') || location.pathname.startsWith('/collection');

  // Condition to hide global widgets (Reviews, WhatsApp, etc.)
  const hideGlobalWidgets = isCheckoutPage || isPaymentCallback || isDigital;

  const getHeaderComponent = () => {
    if (hideGlobalWidgets) return null;
    if (isMobile && isProductPage) return <Header3 location={location} />;
    if (isMobile && isGuestCheckoutPage) return <Header3 location={location} />;
    if (isMobile && isUserPage) return <Header2 location={location} />;
    return <Header />;
  };

  const getFooterComponent = () => {
    if (isCheckoutPage || isGuestCheckoutPage) return <CheckoutFooter/>;
    if (isPaymentCallback || isDigital) return null;
    return <Footer />;
  };
 const getLoaderText = () => {
      if (isDigital) return "Authenticating your handcrafted masterpiece...";
      if (isCheckoutPage) return "Preparing secure checkout...";
      return "Loading Kanthasri Archives...";
  };
  return (
    <Context.Provider value={{ getUser }}>
      <Suspense fallback={<KanthasriLoader text={getLoaderText()} />}>
        <ToastContainer position='top-center' />
        <AnnouncementBanner /> 
        
        {getHeaderComponent()}
        
        <main className='min-h-[calc(100vh-140px)]'>
          
          <Outlet />
        </main>

        {/* --- CONDITIONALLY RENDERED REVIEW COMPONENTS --- */}
        {!hideGlobalWidgets && (
          <>
            <button
              onClick={() => setIsReviewOpen(true)}
              style={{ backgroundColor: 'rgb(41, 64, 96)' }}
              className="fixed right-0 top-1/2 -translate-y-1/2 z-[50] text-white px-2 py-8 rounded-l-lg hover:pr-4 transition-all duration-300 [writing-mode:vertical-lr] text-[10px] font-bold uppercase tracking-[0.3em] shadow-2xl border-l border-y border-white/20"
            >
              Reviews
            </button>

            <ReviewDrawer
              isOpen={isReviewOpen} 
              onClose={() => setIsReviewOpen(false)} 
            />
          </>
        )}

        <WhatsAppWidget />
        {getFooterComponent()}
      </Suspense>
    </Context.Provider>
  );
}

export default App;